import {AfterViewInit, ApplicationRef, Component, OnInit, ViewChild} from '@angular/core';

import {EventDatabaseService} from './event-database.service';
import {
  NextEventGridConfiguration, NextEventRequestModel, PastEventGridConfiguration,
  PastEventRequestModel
} from './event-database.model';
import {DxGridHelper} from '../../shared/helpers/dx-grid-helper';

@Component({
  selector: 'app-event-database',
  templateUrl: './event-database.component.html',
  providers: [EventDatabaseService],
  styleUrls: ['./event-database.component.less']
})
export class EventDatabaseComponent implements OnInit, AfterViewInit {

  @ViewChild('pastGrid') private pastGrid;
  @ViewChild('nextGrid') private nextGrid;

  selectedEventId: number;
  selectedEventName: string;
  showEvent = false;
  showEditGuests = false;
  cloneExistingEvent = false;

  nextEventsGridConfiguration = new NextEventGridConfiguration();
  nextEventsGridRequest = new NextEventRequestModel();

  pastEventsGridConfiguration = new PastEventGridConfiguration();
  pastEventsGridRequest = new PastEventRequestModel();

  constructor(private eventDatabaseService: EventDatabaseService, private appRef: ApplicationRef) {
  }

  ngOnInit() {
    const now = new Date();
    this.nextEventsGridConfiguration.service = this.eventDatabaseService;
    this.pastEventsGridConfiguration.service = this.eventDatabaseService;
  }
  ngAfterViewInit(): void {
    DxGridHelper.ConfigureGrid(this.nextGrid, this.nextEventsGridRequest, this.nextEventsGridConfiguration);
    this.nextEventsGridConfiguration.dataGrid.onRowClick.subscribe((e) => {
      this.show(e.data.id);
    });
    DxGridHelper.ConfigureGrid(this.pastGrid, this.pastEventsGridRequest, this.pastEventsGridConfiguration);
    this.pastEventsGridConfiguration.dataGrid.onRowClick.subscribe((e) => {
      this.show(e.data.id);
    });
  }

  showAttendees(event) {
    this.selectedEventId = event.id;
    this.selectedEventName = event.name;
    this.showEditGuests = true;
  }
  show(eventId) {
    this.selectedEventId = eventId;
    this.cloneExistingEvent = false;
    this.showEvent = true;
  }
  cloneEvent(eventId) {
    this.selectedEventId = eventId;
    this.cloneExistingEvent = true;
    this.showEvent = true;
  }
  newEvent() {
    this.selectedEventId = null;
    this.cloneExistingEvent = false;
    this.showEvent = true;
  }
  closePopUp(refresh) {
    this.showEvent = false;
    this.showEditGuests = false;
    if (refresh) {
      this.nextEventsGridConfiguration.reloadGrid();
      this.pastEventsGridConfiguration.reloadGrid();
    }
  }

  search(value) {
    this.nextEventsGridConfiguration.customSearch[0].value = value;
    this.nextEventsGridConfiguration.dataGrid.instance.getDataSource().reload();
    this.pastEventsGridConfiguration.customSearch[0].value = value;
    this.pastEventsGridConfiguration.dataGrid.instance.getDataSource().reload();
  }


}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/events/event-database/event-database.component.ts